<!-- 短信模板管理 -->
<template>
  <div class="smsTemplateManagement">
    <div class="sms_top">
      <span
        v-if="allowsPerm.delete"
        id="del"
        @click="delDialog(multipleSelection)"
        ><span class="del-icon"></span>删除</span
      >
      <span v-if="allowsPerm.update" id="edit" @click="editDialog"
        ><span class="edit-icon"></span>编辑</span
      >
      <span v-if="allowsPerm.insert" id="add" @click="addDialog"
        ><span class="add-icon"></span>新增</span
      >
    </div>
    <div class="sms_bottom" ref="sms_bottom">
      <div ref="table">
        <el-table
          v-loading="loading"
          ref="multipleTable"
          :data="tableData"
          :header-cell-style="{ background: '#edf1f7' }"
          :max-height="height"
          border
          @selection-change="handleCurrentChange"
          @row-click="clickRow"
        >
          <el-table-column type="selection" width="40" align="center"></el-table-column>
          <el-table-column
            type="index"
            align="center"
            header-align="center"
            label="序号"
            width="60"
          >
          </el-table-column>
          <el-table-column
            align="left"
            header-align="left"
            prop="message"
            label="模板内容"
            min-width="400"
          >
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            prop="sendTime"
            label="修改时间"
            min-width="100"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增/编辑 -->
    <el-dialog
      class="abow_dialog"
      :title="status + '短信模板'"
      :visible.sync="addbtn"
      :close-on-click-modal="false"
    >
      <fieldset>
        <legend class="legend">模板内容</legend>
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入模板内容"
          v-model="form.message"
        ></el-input>
      </fieldset>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">关 闭</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import warnTypes from '@/store/types/warningcenter'

export default {
  data () {
    return {
      loading: true,
      height: 10,
      value: '',
      selecttime: '',
      tableData: [],
      multipleSelection: [],
      addbtn: false,
      status: '新增',
      form: {},
      iD: '',
      message: '',
      pageIndex: '1',
      pageSize: '100',
      delId: []
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.multipleSelection = val
    },
    getTableData () {
      this.loading = true
      this.$store.dispatch(warnTypes.GET_MESSAGE_TEMPLATELIST, {
        iD: this.iD,
        message: this.message,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.tableData = data.results
        this.loading = false
      })
    },
    addDialog () {
      this.status = '新增'
      this.form = {}
      this.addbtn = true
    },
    editDialog () {
      this.status = '编辑'
      if (this.multipleSelection.length < 1) {
        this.$alert('需要选择一条数据才可进行该操作！请选择其中一条数据。', '提示')
      } else if (this.multipleSelection.length > 1) {
        this.$alert('该操作不可对多条数据同时进行操作。', '提示')
      } else {
        this.form = {}
        this.addbtn = true
        this.form = Object.assign({}, this.multipleSelection[0])
      }
    },
    delDialog (rows) {
      if (rows < 1) {
        this.$alert('请先勾选需要删除的数据项！', '提示')
      } else {
        this.delId = [] // 清空数组
        rows.forEach(item => {
          this.delId.push(item.id)
        })
        this.$confirm(`确定要删除已选择的数据 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(warnTypes.DELEDE_MESSAGE_TEMPLATE, { id: this.delId.join(',') }).then(() => {
            this.loading = false
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.getTableData()
          }).catch(() => { this.loading = false })
        }).catch(() => { })
      }
    },
    onGroupSave () {
      if (!this.form.message) {
        this.$notify.error({
          message: '模板内容不能为空'
        })
        return
      }
      this.loading = true
      this.$store.dispatch(warnTypes.SAVE_MESSAGE_TEMPLATE, this.form).then(() => {
        this.loading = false
        this.addbtn = false
        this.$notify.success({ title: '成功', message: '保存成功。' })
        this.getTableData()
        this.form = {}
      }).catch(() => { this.loading = false })
    },
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
  },
  mounted () {
    this.getTableData()
    this.Global.elementFix(this, this.$refs['table'], document.getElementById('refline1'), false, (height) => {
      this.height = height
    })
  }
}
</script>
<style lang="less" src="@/assets/warningcenter.less" scoped></style>
<style lang="less" scoped>
/* 外层样式 */
.smsTemplateManagement {
  width: 100%;
  padding: 15px;
  height: 100%;
  position: relative;
  // top: -80px;
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #ecf5ff;
  }
  /deep/ .abow_dialog .el-form-item:nth-child(1) .el-form-item__label {
    color: red;
  }
  /deep/ .abow_dialog .el-form-item:nth-child(2) .el-form-item__label {
    font-size: 18px;
    color: #333;
  }
}
/* top */
.sms_top {
  width: 100%;
  height: 80px;
  margin-bottom: 15px;
  padding: 15px;
  background: #ffffff;
}
.sms_top .select .desc {
  width: 80px;
  height: 35px;
  float: left;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 600;
  line-height: 35px;
}
.sms_top .select {
  width: 520px;
  height: 35px;
  float: left;
}
.sms_top #del {
  font-size: 16px;
  padding: 9px 8px;
  background-color: #fda72c;
  cursor: pointer;
  float: right;
  color: #ffffff;
  border-radius: 3px;
  margin-right: 20px;
  margin-top: 3px;
}
.sms_top #del:hover {
  background-color: #f38b04;
}
.sms_top .del-icon {
  width: 18px;
  height: 17px;
  display: block;
  background-image: url('~@/assets/monitorimg/del.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-right: 5px;
  float: left;
  margin-top: 2px;
}
.sms_top #edit {
  font-size: 16px;
  padding: 9px 8px;
  background-color: #01b8cc;
  cursor: pointer;
  float: right;
  color: #ffffff;
  border-radius: 3px;
  margin-right: 20px;
  margin-top: 3px;
}
.sms_top #edit:hover {
  background-color: rgb(107, 201, 211);
}
.sms_top .edit-icon {
  width: 18px;
  height: 17px;
  display: block;
  background-image: url('~@/assets/monitorimg/edit.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-right: 5px;
  float: left;
  margin-top: 2px;
}
.sms_top #add {
  font-size: 16px;
  padding: 9px 8px;
  background-color: #3e81fc;
  cursor: pointer;
  float: right;
  color: #ffffff;
  border-radius: 3px;
  margin-right: 20px;
  margin-top: 3px;
}
.sms_top #add:hover {
  background-color: #4d8cff;
}
.sms_top .add-icon {
  width: 18px;
  height: 17px;
  display: block;
  background-image: url('~@/assets/monitorimg/add.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-right: 5px;
  float: left;
  margin-top: 2px;
}
.sentType {
  width: 325px;
  float: left;
}
.sentType .fsfs {
  width: 80px;
  height: 35px;
  float: left;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 600;
  line-height: 35px;
}
.sentType .selectContent {
  width: 225px;
  float: left;
}
.sms_top #search {
  width: 75px;
  height: 38px;
  float: left;
  margin-left: 10px;
  background: #1d8af8;
  border: 0.03125rem solid #1d8af8;
  color: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  border-radius: 5px;
  cursor: pointer;
}
/* bottom */
.sms_bottom {
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  padding-top: 15px;
  padding-bottom: 15px;
  > div {
    width: 98%;
    margin-left: 1%;
  }
}
/* 新建/编辑 */
.abow_dialog .el-form-item {
  float: left;
}
.abow_dialog .el-form-item:nth-child(1) {
  width: 170px;
  height: 45px;
}
.abow_dialog .el-form-item:nth-child(2) {
  width: 75%;
  margin-left: -90px;
}
.legend {
  width: auto;
  margin-bottom: 0;
  padding: 0 10px;
  border: none;
  color: #6a9bf3;
  font: 500 18px 'Microsoft YaHei UI';
}
</style>
